@if (beneficiaire && beneficiaire.codeSrvAMOBenef != undefined) {
  <div class="situspec">{{(beneficiaire && beneficiaire.codeSrvAMOBenef!=undefined?constants.sitspecsmsg[beneficiaire.codeSrvAMOBenef]:'')}}</div>
}

<div>
  <div class="flexrow ">
    <span class="title">Nom usuel</span><span class="value">{{ beneficiaire?.nomUsuel }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Nom de famille</span><span class="value">{{ beneficiaire?.nomFamille }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Prénom</span><span class="value">{{ beneficiaire?.prenom }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">NIR certifié</span><span class="value">{{ beneficiaire?.numSecuCertif }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Date certif. NIR</span><span class="value">{{ utils.toFRformat($safeNavigationMigration(beneficiaire?.dateCertifNumSecu)) }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Date naissance</span><span class="value">{{ utils.toFRformat($safeNavigationMigration(beneficiaire?.dateNaissance)) }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Adresse 1</span><span class="value">{{ beneficiaire?.adresse1 }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Adresse 2</span><span class="value">{{ beneficiaire?.adresse2 }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Adresse 3</span><span class="value">{{ beneficiaire?.adresse3 }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Adresse 4</span><span class="value">{{ beneficiaire?.adresse4 }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Adresse 5</span><span class="value">{{ beneficiaire?.adresse5 }}</span>
  </div>
  <div class="flexrow ">
    <span class="title">Qualité</span><span class="value">{{ beneficiaire?.qualite }}</span>
  </div>
</div>

@if (beneficiaire && beneficiaire.donneesMutuelle) {
  <div>
    <div class="title sectiontitle">Mutuelle an gestion unique</div>
    <div class="flexrow ">
      <span class="title">&nbsp;MUTNUM</span><span class="value">{{ beneficiaire.donneesMutuelle.mutnum }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Garanties</span><span class="value">{{ beneficiaire.donneesMutuelle.garanties }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Poss. Trait. TP</span><span class="value">{{ beneficiaire.donneesMutuelle.indicTraitMutuelle }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Type de service</span><span class="value">{{ beneficiaire.donneesMutuelle.typeService }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;N° AMC</span><span class="value">{{ beneficiaire.donneesMutuelle.service }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Aiguillage STS</span><span class="value">{{ beneficiaire.donneesMutuelle.aiguillageSTS }}</span>
    </div>
  </div>
}

@if (beneficiaire && beneficiaire.donneesAMC) {
  <div>
    <div class="title sectiontitle">Mutuelle en gestion séparée</div>
    <div class="flexrow ">
      <span class="title">&nbsp;Id AMC</span><span class="value">{{ beneficiaire.donneesAMC.numAMC }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Id Adhérent</span><span class="value">{{ beneficiaire.donneesAMC.numAdherent }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Ind. Trait. AMC</span><span class="value">{{ beneficiaire.donneesAMC.indicTraitAMC }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Type de service</span><span class="value">{{ beneficiaire.donneesAMC.typeService }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Service</span><span class="value">{{ beneficiaire.donneesAMC.service }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Aiguillage STS</span><span class="value">{{ beneficiaire.donneesAMC.aiguillageSTS }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Code routage</span><span class="value">{{ beneficiaire.donneesAMC.codeRoutage }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Id Hôte</span><span class="value">{{ beneficiaire.donneesAMC.idHote }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Nom de domaine</span><span class="value">{{ beneficiaire.donneesAMC.domaine }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Date début</span><span class="value">{{ beneficiaire.donneesAMC.dateDebut }}</span>
    </div>
    <div class="flexrow ">
      <span class="title">&nbsp;Date fin</span><span class="value">{{ beneficiaire.donneesAMC.dateFin }}</span>
    </div>
  </div>
}

